import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ButtonWrap } from "@hopper-b2b/ui";
import { DialogTitle, DialogContent, Divider } from "@material-ui/core";
import PhoneIcon from "../../assets/client/phone.svg?react";
import WhatsAppIcon from "../../assets/client/whatsapp.svg?react";
import {
  INSURANCE_PHONE_NUMBER,
  INSURANCE_WHATSAPP_LINK,
} from "../MobileHamburgerMenu/constants";

// This is a custom contact support modal content, based off of ContactSupportModalContent
// Even though it is "different", the styles and structure are the same
const TravelInsuranceContactSupportModalContent = () => {
  const { t } = useI18nContext();

  const whatsAppHandler = useCallback(() => {
    window.open(INSURANCE_WHATSAPP_LINK, "_blank");
  }, []);

  const phoneHandler = useCallback(() => {
    window.location.href = `tel:${INSURANCE_PHONE_NUMBER}`;
  }, []);

  return (
    <div className="contact-support-modal-content-container">
      <DialogTitle className="contact-support-modal-title" disableTypography>
        <h2 className="title">{t("contactSupport")}</h2>
        <p className="subtitle">{t("contactSupportMethod")}</p>
      </DialogTitle>
      <DialogContent className="contact-support-modal-content">
        <ButtonWrap className="support-action-row" onClick={whatsAppHandler}>
          <WhatsAppIcon className="support-action-row-icon" />
          <div className="support-action-row-content">
            <p className="support-action-row-title">{t("whatsApp")}</p>
          </div>
        </ButtonWrap>
        <Divider />
        <ButtonWrap className="support-action-row" onClick={phoneHandler}>
          <PhoneIcon className="support-action-row-icon" />
          <div className="support-action-row-content">
            <p className="support-action-row-title">{t("phone")}</p>
            <p className="support-action-row-subtitle">
              {t("insurancePhoneSubtitle")}
            </p>
          </div>
        </ButtonWrap>
      </DialogContent>
    </div>
  );
};

export default TravelInsuranceContactSupportModalContent;
